import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { ReactElement } from 'react';
import { S_Tab } from '../../../../design/tabs/tab/S_Tab';
import { S_TabsContainer } from '../../../../design/tabs/tabsContainer/S_TabsContainer';
import { ICurrentWorkspaceStore } from '../../../workspaces/currentWorkspace/CurrentWorkspace.store';
import { JOB_TYPE } from '../../jobs.model';
import { getJobRoutePrefix, getJobTranslationPrefix } from '../../utils';

interface IJobsTabsContainerProps {
  jobType: JOB_TYPE;
}

export const JobsTabsContainer = ({ jobType }: IJobsTabsContainerProps): ReactElement => {
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const { t } = useTranslator();

  const path = window.location.pathname;
  let filterIndex = ['all', 'owned', 'others'].findIndex((s) => path.includes(s));
  if (filterIndex < 0) {
    filterIndex = 0;
  }

  const workspaceId = currentWorkspaceStore.currentWorkspace.id;
  const route = getJobRoutePrefix(jobType).List;
  const translationPrefix = getJobTranslationPrefix(jobType);

  return (
    <S_TabsContainer>
      <S_Tab
        text={t(`${translationPrefix}.list.tabs.all`)}
        link={route.All.withParams({ workspaceId })}
        state={filterIndex === 0 ? 'active' : 'passive'}
      />
      <S_Tab
        text={t(`${translationPrefix}.list.tabs.my`)}
        link={route.Owned.withParams({ workspaceId })}
        state={filterIndex === 1 ? 'active' : 'passive'}
      />
      <S_Tab
        text={t(`${translationPrefix}.list.tabs.other`)}
        link={route.Others.withParams({ workspaceId })}
        state={filterIndex === 2 ? 'active' : 'passive'}
      />
    </S_TabsContainer>
  );
};
